// src/Banner.jsx – Cookie-Banner. Erscheint beim ersten Besuch und über „Cookie-Einstellungen“ (Fußzeile, Datenschutzseite).
// Was nach der Auswahl geladen wird, steuert src/consent.js.
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./components/pages/custom.css";
import { leseEinwilligung, speichereEinwilligung, OEFFNEN_EVENT } from "./consent";

const KATEGORIEN = [
  {
    id: "statistik",
    titel: "Statistik (PostHog)",
    text: "Zählt Seitenaufrufe, damit wir sehen, welche Inhalte gelesen werden. Server in der EU (Frankfurt).",
  },
  {
    id: "marketing",
    titel: "Marketing (Google Ads)",
    text: "Misst, ob unsere Google-Anzeigen zu Anfragen führen. Daten können in die USA übermittelt werden.",
  },
];

export function Banner() {
  const [offen, setOffen] = useState(() => leseEinwilligung() === null);
  const [details, setDetails] = useState(false);
  const [auswahl, setAuswahl] = useState({ statistik: false, marketing: false });
  // Beim Öffnen über „Cookie-Einstellungen“ den Fokus in den Dialog setzen und danach zum Auslöser zurückgeben
  const dialogRef = useRef(null);
  const ausloeser = useRef(null);
  const [fokussieren, setFokussieren] = useState(false);

  useEffect(() => {
    const oeffnen = () => {
      ausloeser.current = document.activeElement;
      setFokussieren(true);
      setAuswahl(leseEinwilligung() || { statistik: false, marketing: false });
      setDetails(true);
      setOffen(true);
    };
    window.addEventListener(OEFFNEN_EVENT, oeffnen);
    return () => window.removeEventListener(OEFFNEN_EVENT, oeffnen);
  }, []);

  useEffect(() => {
    if (offen && fokussieren) {
      dialogRef.current?.focus();
      setFokussieren(false);
    }
  }, [offen, fokussieren]);

  const speichern = (wert) => {
    speichereEinwilligung(wert);
    setOffen(false);
    setDetails(false);
    if (ausloeser.current && document.contains(ausloeser.current)) ausloeser.current.focus();
    ausloeser.current = null;
  };

  if (!offen) return null;

  return (
    <div
      data-cookie-banner
      ref={dialogRef}
      tabIndex={-1}
      role="dialog"
      aria-label="Cookie-Einstellungen"
      className="position-fixed bottom-0 start-0 end-0 p-3 shadow-lg"
      style={{ zIndex: 9999, background: "var(--ff-black)", borderTop: "1px solid var(--ff-border)", color: "var(--ff-white)" }}
    >
      <div className="container">
        <p className="mb-3" style={{ fontSize: ".95rem", maxWidth: "70rem" }}>
          Wir möchten mit Ihrer Einwilligung eine Besucherstatistik (PostHog) und die Erfolgsmessung unserer
          Google-Anzeigen nutzen. Dafür werden Daten in Ihrem Browser gespeichert und an die Anbieter übertragen.
          Notwendig für die Seite ist nur das Speichern Ihrer Auswahl. Sie können sie jederzeit unter
          „Cookie-Einstellungen“ unten auf der Seite ändern. Mehr in der{" "}
          <Link to="/datenschutz" style={{ color: "var(--ff-grass)" }}>
            Datenschutzerklärung
          </Link>
          .
        </p>

        {details && (
          <div className="mb-3">
            {KATEGORIEN.map(({ id, titel, text }) => (
              <div className="form-check mb-2" key={id}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`consent-${id}`}
                  checked={auswahl[id]}
                  onChange={(e) => setAuswahl({ ...auswahl, [id]: e.target.checked })}
                />
                <label className="form-check-label" htmlFor={`consent-${id}`} style={{ fontSize: ".9rem" }}>
                  <strong>{titel}</strong>: <span style={{ color: "var(--ff-muted)" }}>{text}</span>
                </label>
              </div>
            ))}
          </div>
        )}

        <div className="d-flex flex-wrap gap-2">
          <button className="btn-ff-primary" onClick={() => speichern({ statistik: true, marketing: true })}>
            Alle akzeptieren
          </button>
          <button className="btn-ff-primary" onClick={() => speichern({ statistik: false, marketing: false })}>
            Alle ablehnen
          </button>
          {details ? (
            <button className="btn-ff-outline" onClick={() => speichern(auswahl)}>
              Auswahl speichern
            </button>
          ) : (
            <button className="btn-ff-outline" onClick={() => setDetails(true)}>
              Einstellungen
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
